export const PaymentType = Object.freeze({
	Subscription: "Subscription",
	Purchase: "Purchase",
});
